import React from 'react';
const bonuses = [{
  num: '01',
  emoji: '🔥',
  title: 'Audio Library EduLabs',
  desc: 'Basi ritmiche e melodiche di alta qualità per ogni lezione, già scaricabili.',
  value: 12
}, {
  num: '02',
  emoji: '📅',
  title: 'Piano Annuale Express',
  desc: 'Documento PTOF pronto da consegnare in segreteria entro fine mese.',
  value: 9
}, {
  num: '03',
  emoji: '🎵',
  title: 'Kit "Flauto Dolce Facile"',
  desc: 'Guida rapida per iniziare lo strumento in 3ª — senza paura e senza spartiti complessi.',
  value: 7
}, {
  num: '04',
  emoji: '🔍',
  title: 'Flashcard dei Compositori',
  desc: '30 carte illustrate per rendere la storia della musica leggendaria.',
  value: 7
}, {
  num: '05',
  emoji: '🏆',
  title: 'Diplomi di "Piccolo Musicista"',
  desc: "Attestati d'onore pronti da stampare per la fine del ciclo.",
  value: 5
}, {
  num: '06',
  emoji: '🌈',
  title: 'Percorsi Semplificati BES/DSA',
  desc: 'Adattamenti metodologici per una classe 100% inclusiva, senza preparazione extra.',
  value: 9
}];
export function BonusSection() {
  return <section className="w-full bg-bg-main py-20 px-4 relative overflow-hidden" data-id="element-27">
      {/* Decorative glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%)'
    }} aria-hidden="true" data-id="element-28"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-29">
        {/* Eyebrow */}
        <div className="text-center mb-4" data-id="element-30">
          <span className="inline-flex items-center gap-2 text-secondary font-bold text-xs sm:text-sm uppercase tracking-wider bg-secondary/10 border border-secondary/30 px-4 py-1.5 rounded-full" data-id="element-31">
            🎁 Bonus inclusi nel Kit
          </span>
        </div>

        {/* Header */}
        <div className="text-center mb-12" data-id="element-32">
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-33">
            +{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-yellow-400" data-id="element-34">
              6 Bonus
            </span>{' '}
            in regalo con il Kit
          </h2>

          {/* Value anchor */}
          <div className="inline-flex flex-wrap items-center justify-center gap-2 sm:gap-3 bg-bg-alt border border-secondary/30 rounded-2xl px-5 sm:px-7 py-3 sm:py-4 shadow-[0_0_30px_rgba(245,158,11,0.15)]" data-id="element-35">
            <span className="text-text-sec font-medium text-sm sm:text-base" data-id="element-36">
              Valore reale:
            </span>
            <span className="text-text-sec line-through font-bold text-lg sm:text-2xl" data-id="element-37">
              €49
            </span>
            <span className="text-text-main font-bold" data-id="element-38">→</span>
            <span className="text-cta-green font-black text-lg sm:text-2xl" data-id="element-39">
              €0 oggi
            </span>
            <span className="hidden sm:inline-block bg-secondary text-bg-dark font-black text-xs px-2 py-0.5 rounded-full ml-1" data-id="element-40">
              IN OMAGGIO
            </span>
          </div>
        </div>

        {/* Bonus list */}
        <div className="space-y-3 sm:space-y-4 mb-10" data-id="element-41">
          {bonuses.map((bonus, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-5 transition-all hover:-translate-y-0.5 hover:border-secondary/40 group relative overflow-hidden" data-id="element-42">
              {/* Subtle gradient on hover */}
              <div className="absolute inset-0 bg-gradient-to-r from-secondary/[0.04] to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-43"></div>

              {/* Number + Emoji Badge */}
              <div className="relative flex items-center gap-3 sm:gap-0 sm:flex-col flex-shrink-0" data-id="element-44">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-secondary/25 to-secondary/5 border border-secondary/30 flex items-center justify-center text-2xl shadow-inner group-hover:from-secondary/40 transition-colors" data-id="element-45">
                  {bonus.emoji}
                </div>
                <span className="sm:hidden text-secondary font-black text-xs" data-id="element-46">
                  BONUS #{bonus.num}
                </span>
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0 relative z-10" data-id="element-47">
                <div className="hidden sm:block text-secondary font-black text-[10px] uppercase tracking-wider mb-1" data-id="element-48">
                  Bonus #{bonus.num}
                </div>
                <h4 className="text-text-main font-black text-lg sm:text-xl mb-1 leading-tight" data-id="element-49">
                  {bonus.title}
                </h4>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-50">
                  {bonus.desc}
                </p>
              </div>

              {/* Value + In Omaggio badge */}
              <div className="relative z-10 flex sm:flex-col items-center sm:items-end gap-2 flex-shrink-0" data-id="element-51">
                <span className="text-text-sec line-through font-bold text-sm sm:text-base" data-id="element-52">
                  €{bonus.value}
                </span>
                <span className="bg-secondary text-bg-dark border border-yellow-300/50 px-3 py-1.5 rounded-lg font-black text-xs sm:text-sm shadow-[0_0_15px_rgba(245,158,11,0.4)]" data-id="element-53">
                  IN OMAGGIO
                </span>
              </div>
            </div>)}
        </div>

        {/* Closing value strip + soft CTA */}
        <div className="bg-gradient-to-br from-secondary/15 to-primary/5 border border-secondary/30 rounded-2xl p-6 sm:p-8 text-center relative overflow-hidden" data-id="element-54">
          <div className="absolute inset-0 pointer-events-none" style={{
          background: 'radial-gradient(circle at center, rgba(245,158,11,0.1) 0%, transparent 70%)'
        }} aria-hidden="true" data-id="element-55"></div>
          <p className="relative text-text-main text-lg sm:text-xl font-bold leading-snug mb-2" data-id="element-56">
            Tutti i 6 bonus <span className="text-secondary" data-id="element-57">(valore €49)</span>{' '}
            sono inclusi — ma{' '}
            <span className="text-cta-green" data-id="element-58">solo nella promo di lancio</span>.
          </p>
          <p className="relative text-text-sec text-sm sm:text-base mb-5" data-id="element-59">
            Domani potrebbero non esserci più.
          </p>
          
        </div>
      </div>
    </section>;
}